<div class="no-matching-search">
  <div class="btv-icon-loop-not-found theme-notFoundMessage__mainImg"></div>
  <p class="no-matching-search__title-result theme-notFoundMessage__mainTitle">{{ lg.noMatchSearch.result }}</p>
  <p class="no-matching-search__title-action theme-notFoundMessage__descr">{{ lg.noMatchSearch.action }}</p>
</div>
